import fetch from "./fetch";
/**
 * 项目管理
 */
const projectManage = {
  //项目列表分页
  getProjectManageList(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-project/page",
      method: "GET",
      params,
    });
  },

  //获取专员分页
  getCommissionerList(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-commissioner/page",
      method: "GET",
      params,
    });
  },

  //根据项目id获取已选专员列表
  getCommissionerListById(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-commissioner/selectList",
      method: "GET",
      params,
    });
  },

  //获取所有项目名称
  getProjectName(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-project/selectList",
      method: "GET",
      params,
    });
  },

  //根据项目id获取项目信息
  getProjectDataById(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-project/select",
      method: "GET",
      params,
    });
  },
  // 查询项目名称是否重复
  checkProjectNameDuplicate(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-project/check",
      method: "GET",
      params,
    });
  },

  //新增项目
  createProjectData(data) {
    return fetch({
      isLoading: true,
      url: "/jkzy-project/insert",
      method: "POST",
      data,
    });
  },

  //编辑项目
  updateProjectData(data) {
    return fetch({
      isLoading: true,
      url: "/jkzy-project/update",
      method: "POST",
      data,
    });
  },

  //启动项目
  startProjectData(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-project/start",
      method: "GET",
      params,
    });
  },

  //停止项目
  stopProjectData(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-project/stop",
      method: "GET",
      params,
    });
  },

  //删除项目
  deleteProjectData(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-project/delete",
      method: "GET",
      params,
    });
  },

  //下载模板
  jkzyDownloadTem() {
    return fetch({
      isLoading: true,
      url: "/jkzy-commissioner/downloadTem",
      method: "GET",
      responseType: "blob",
    });
  },

  //修改健康专员
  jkzyCommissionerUpdate(data) {
    return fetch({
      isLoading: true,
      url: "/jkzy-commissioner/update",
      method: "POST",
      data,
    });
  },
  //删除健康专员
  jkzyCommissionerDelete(data) {
    return fetch({
      isLoading: true,
      url: "/jkzy-commissioner/delete",
      method: "POST",
      data,
    });
  },
  //导入保存专员
  jkzyCommissionerSave(data, projectId) {
    return fetch({
      isLoading: true,
      url: `/jkzy-commissioner/saveCommissioner?projectId=${projectId}`,
      method: "POST",
      data,
    });
  },

  //健康专员拜访分页
  getVisitRecord(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-visitRecord/page",
      method: "GET",
      params,
    });
  },

  //健康专员医院分页
  jkzyGetHospital(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-hospital/page",
      method: "GET",
      params,
    });
  },

  //健康专员医院新增
  jkzyCreateHospital(data) {
    return fetch({
      isLoading: true,
      url: "/jkzy-hospital/save",
      method: "POST",
      data,
    });
  },
  //健康专员医院修改
  jkzyUpdateHospital(data) {
    return fetch({
      isLoading: true,
      url: "/jkzy-hospital/update",
      method: "POST",
      data,
    });
  },

  //健康专员医院删除
  jkzyDeleteHospital(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-hospital/delete",
      method: "GET",
      params,
    });
  },

  //健康专员导入医院列表
  jkzyImportHospital(data, projectId) {
    return fetch({
      isLoading: true,
      url: `/jkzy-hospital/import?projectId=${projectId}`,
      method: "POST",
      hideError: true,
      data,
    });
  },

  //健康专员模糊查询项目
  jkzyGetProjectByName(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-project/getProject",
      method: "GET",
      params,
    });
  },

  //健康专员模糊查询专员
  jkzyGetCommissionerByName(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-commissioner/getCommissioner",
      method: "GET",
      params,
    });
  },

  //省市区查询
  jkzyGetLocation(params) {
    return fetch({
      isLoading: true,
      url: "/config/china/list",
      method: "GET",
      params,
    });
  },

  //健康专员导入药房列表
  jkzyImportPharmacy(data, projectId) {
    return fetch({
      isLoading: true,
      url: `/jkzy-pharmacy/import?projectId=${projectId}`,
      method: "POST",
      hideError: true,
      data,
    });
  },

  //健康专员药房分页
  jkzyGetPharmacy(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-pharmacy/page",
      method: "GET",
      params,
    });
  },

  //健康专员药房详情
  jkzyPharmacyDetail(id) {
    return fetch({
      isLoading: true,
      url: `/jkzy-pharmacy/${id}`,
      method: "GET",
    });
  },

  //健康专员药房查询医生关联医院
  jkzyPharmacyHospitalList(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-pharmacy/hospitalList",
      method: "GET",
      params,
    });
  },

  //健康专员药房获取售卖商品
  jkzyDmGoodsList(params) {
    return fetch({
      isLoading: true,
      url: "/dm-goods/list",
      method: "GET",
      params,
    });
  },

  //健康专员药房新增
  jkzyCreatePharmacy(data) {
    return fetch({
      isLoading: true,
      url: "/jkzy-pharmacy/save",
      method: "POST",
      data,
    });
  },
  //健康专员药房修改
  jkzyUpdatePharmacy(data) {
    return fetch({
      isLoading: true,
      url: "/jkzy-pharmacy/update",
      method: "POST",
      data,
    });
  },

  //健康专员药房删除
  jkzyDeletePharmacy(params) {
    return fetch({
      isLoading: true,
      url: "/jkzy-pharmacy/delete",
      method: "GET",
      params,
    });
  },

  //修改健康专员
  jkzyCommissionerSaveAndUpdate(data) {
    return fetch({
      isLoading: true,
      url: "/jkzy-commissioner/saveAndUpdate",
      method: "POST",
      data,
    });
  },

  //所有项目分页
  getAllProjectPage(params) {
    return fetch({
      isLoading: true,
      url: "/channel/page",
      method: "GET",
      params,
    });
  },

  //所有项目新增
  createAllProject(data) {
    return fetch({
      isLoading: true,
      url: "/channel/save",
      method: "POST",
      data,
    });
  },

  //所有项目修改
  updateAllProject(data) {
    return fetch({
      isLoading: true,
      url: "/channel/update",
      method: "POST",
      data,
    });
  },

  //所有项目启动
  startAllProject(data) {
    return fetch({
      isLoading: true,
      url: "/channel/start",
      method: "POST",
      data,
    });
  },

  //所有项目导入
  importAllProject(data, projectId) {
    return fetch({
      isLoading: true,
      url: `/channel/import?projectId=${projectId}`,
      method: "POST",
      hideError: true,
      data,
    });
  },

  //查询所有项目
  searchAllProject(params){
    return fetch({
      isLoading: true,
      url: "/channel/list",
      method: "GET",
      params,
    });
  }, 
  //所有机构分页
  getInstitutionPage(params) {
    return fetch({
      isLoading: true,
      url: "/organization/page",
      method: "GET",
      params,
    });
  },

  //新增机构
  createInstitution(data) {
    return fetch({
      isLoading: true,
      url: "/organization/save",
      method: "POST",
      data,
    });
  },

  //修改机构
  updateInstitution(data) {
    return fetch({
      isLoading: true,
      url: "/organization/update",
      method: "POST",
      data,
    });
  },

  //导入机构
  importInstitution(data, projectId) {
    return fetch({
      isLoading: true,
      url: `/organization/import?projectId=${projectId}`,
      method: "POST",
      hideError: true,
      data,
    });
  },
  //商品管理分页
  getGoodsPage(params) {
    return fetch({
      isLoading: true,
      url: "/dm-goods/page",
      method: "GET",
      params,
    });
  },

  //新增商品
  addGoods(data) {
    return fetch({
      isLoading: true,
      url: `/dm-goods/save`,
      method: "POST",
      data,
    });
  },
  //修改商品
  updateGoods(data) {
    return fetch({
      isLoading: true,
      url: `/dm-goods/update`,
      method: "POST",
      data,
    });
  },

  //根据id获取商品详情
  getGoodsDetail(id) {
    return fetch({
      isLoading: true,
      url: `/dm-goods/${id}`,
      method: "GET",
    });
  },
};

export default projectManage;
